import { wrapIcon } from 'components/Icons';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';

export const LeftArrow = wrapIcon(RiArrowLeftSLine);
export const RightArrow = wrapIcon(RiArrowRightSLine);
